import React from 'react';

const About = () => {
  console.log('About page loaded!');
  
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="h-[400px] sm:h-[500px] md:h-[600px] relative flex items-center justify-center overflow-hidden">
        <div className="relative z-10 text-center px-4 sm:px-8">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-stone-900 mb-4 sm:mb-6 tracking-tighter">
            About Jatin Interiors
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-stone-600 max-w-xs sm:max-w-md md:max-w-2xl mx-auto">
            Luxury interiors crafted with precision, planning, and premium finishes
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-8 md:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 md:gap-16 items-center">
            <div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 md:mb-8 text-stone-900">Our Story</h2>
              <p className="text-stone-600 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
                Jatin Interiors is a Panipat-based interior design studio known for premium residential and commercial interiors—modular kitchens, living rooms, bedrooms, wardrobes, TV panels, false ceilings, and complete turnkey execution.
              </p>
              <p className="text-stone-600 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
                Our process is simple: we listen to your lifestyle needs, plan the layout with smart storage, finalize finishes and lighting, and deliver a clean installation with consistent after-support—so your space looks great and works even better.
              </p>
              <p className="text-stone-600 leading-relaxed text-sm sm:text-base">
                This website and brand communication are supported by{' '}
                <a
                  href="https://www.larawansdigital.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-semibold text-[#C8A96A] hover:text-amber-600 transition-colors"
                >
                  Larawans Digital, Kaithal
                </a>
                , helping us share our work with the right audience through SEO-friendly content, performance optimization, and a smooth user experience.
              </p>
            </div>
            <div className="aspect-square md:aspect-auto w-full h-[300px] sm:h-[400px] md:h-auto bg-surface-container rounded-xl overflow-hidden">
              <img 
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuC2Gbn0IJg0rCrTjCIYMabD86Rxx8kB1eI0CSXrvRoI1w-e4-M5XEK7pQD1GCXRrP1Ovtm5hRk83jPXJsKm8-PUGyX4T5tDNIU96RhcI4ews7ER3_UAj0c440ux1T2aPEHr_5ln_lPU_y1XOUNRy3bgRczZ0GMN9IeC1uC8PB7QGmdffWsTBTP_c4pQClLnczyA0mHGGcTPlfKy0C-DNRfzW41DvkkVlFNIK2SwF3ABDopXKMU9dAIThZCDd4XdhSjEj96pHJkZY_bA"
                alt="Our design studio"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-8 md:px-16 bg-surface-container-low">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-8 sm:mb-12 md:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 text-stone-900">Our Philosophy</h2>
            <p className="text-base sm:text-lg md:text-xl text-stone-600 max-w-2xl sm:max-w-3xl mx-auto">
              We believe that great design should evoke emotion while serving function
            </p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
            <div className="text-center p-4 sm:p-6 md:p-8">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <span className="material-symbols-outlined text-white text-lg sm:text-2xl">palette</span>
              </div>
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold mb-3 sm:mb-4 text-stone-900">Tactile Materiality</h3>
              <p className="text-stone-600 text-sm sm:text-base">
                Every texture is carefully chosen to create a sensory experience that resonates with human touch
              </p>
            </div>
            
            <div className="text-center p-4 sm:p-6 md:p-8">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <span className="material-symbols-outlined text-white text-lg sm:text-2xl">computer</span>
              </div>
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold mb-3 sm:mb-4 text-stone-900">Digital Precision</h3>
              <p className="text-stone-600 text-sm sm:text-base">
                Cutting-edge technology ensures every detail is perfect before implementation begins
              </p>
            </div>
            
            <div className="text-center p-4 sm:p-6 md:p-8">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <span className="material-symbols-outlined text-white text-lg sm:text-2xl">favorite</span>
              </div>
              <h3 className="text-lg sm:text-xl md:text-2xl font-bold mb-3 sm:mb-4 text-stone-900">Emotional Design</h3>
              <p className="text-stone-600 text-sm sm:text-base">
                Spaces are crafted to tell stories and create meaningful connections with their inhabitants
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-8 md:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-8 sm:mb-12 md:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 text-stone-900">Meet Our Team</h2>
            <p className="text-base sm:text-lg md:text-xl text-stone-600 max-w-2xl sm:max-w-3xl mx-auto">
              Talented individuals united by passion for exceptional design
            </p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {[
              { name: "Sarah Chen", role: "Creative Director", image: "https://lh3.googleusercontent.com/aida-public/AB6AXuAOjNQ5-AjF4G4D6WxhZ03g0OSPhqASmr05dUY0j3NtN7zjr5mz1B0t8I8GVtWpkx2ULcAxqTZnVYe_pMCKVL0UPQBknMjr3BoeJkGzecYWB_d2HVdpmFyCaBlYbDrj9PeUXqGngcwc8Zx20h_LtBxlWzEjjHmS5JCIDf4ENqQkh4cAb8rU35wvh09ZJxk_uc6i9v--902aoUr6EFmlQX1wZ__4GM15BJvCtW2NbNrGTq1l55k1XSy06eZ7CwJwjhpLNfO8ft-ThN88" },
              { name: "Marcus Thorne", role: "Lead Architect", image: "https://lh3.googleusercontent.com/aida-public/AB6AXuAlx3tRaV6p1Z0RzKC7IvkjZQtghnRAxSMvOEC1CTZAt_m6y89IWKPpfTNr7QnOO4bDybNl7PFSFsgEpjEy6lwo__Dpm8H_5J21KP7GaGTpQI2Vhi_DFqBATzarKBo_j_IbpvnpllMP8YutG8pQyUZr8lLySX0-Wp0Cj-9iM7j2dTPNt4kCfodmJXP1Z9ZhcabPYjloWJk8nt2Uc1YhEkLuv7rFwBfaYDCMFzasl-cpKCCL9cFEKLXaZE6Av8E4QZ1Us_Jnrqkn_5Q8" },
              { name: "Elena Rossi", role: "Interior Designer", image: "https://lh3.googleusercontent.com/aida-public/AB6AXuASXIxe3e3_CVcJqAQiXXoCTYhlUWBFrkHhS3RvF2HVqF9XnaNJ7-_3gSfaVVhcHbAbqClIf_2pndp1dVJF6tQOfRdeJBVflXiic4d4cOL3r35FJ9iuXOp1RzNpeZvY4EVjzOoXEGHcNxSc62eYGV5Y60mqhx6191NyMPIUZ2InxTSeR7ewjEopwaCKpa7dghX7Fo3Xup6eOUvo9u-mnLlOD7Zioaz7JMlIxfj6c7CrnaMJx7nNOz3IYjtD48G93VNmo75NlcjItxgS" },
              { name: "David Park", role: "3D Visualization", image: "https://lh3.googleusercontent.com/aida-public/AB6AXuBSQIWC_9b-9Gjt-ZNGBs587OPT_qMy5VqudzWVqUI_4yXpJr_vMqfHqsPBLjDqRB-N5vAfFk-vxuRgE1UGgUD-JTZHiO5u0vW55uTnG9JIumYKaJFR3sQNBWFKaKsycDW9l91c0glxzkJiUPIGibUIdVl1FO6wO1xiRHd96W4Oog1Uf86cUsvu5T0DtoVDNCY1JTTWXyjIhKcpF6HcbjOvARl6r8ZptiFfG4yplfajJQCgsOuP9GRQxa0_KY8HAdjNQHIdbTaFRVF5" }
            ].map((member, index) => (
              <div key={index} className="text-center group">
                <div className="aspect-square rounded-xl overflow-hidden mb-3 sm:mb-4 bg-surface-container h-[200px] sm:h-[250px] md:h-auto">
                  <img 
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <h4 className="font-bold text-sm sm:text-base md:text-lg text-stone-900">{member.name}</h4>
                <p className="text-stone-600 text-xs sm:text-sm">{member.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
